
import React, { useEffect, useState, useRef } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import moment from "moment";
import 'moment-timezone';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@material-ui/core";
import {
    getReportTemplateParameter,
    getNbsData,
    getBookingByNbsForm,
    createNewReport,
    getUpdatedCustomerReportData,
    updateReport,
    resetBookingData,

} from "../../../actions/LimsAdminActions"
import logo from "../../../../redcliffe_logo.jpeg";
import callIcon from "../../../../callicon.png";
import maillIcon from "../../../../mailicon.png";
import qcCode from "../../../../qrcode.png";
import iso from "../../../../iso.png";
import { useNavigate } from 'react-router-dom';
import browserIcon from "../../../../browsericon.png";
import ReactToPrint from "react-to-print";
import { useParams } from "react-router-dom";
import QRCode from "react-qr-code";
import { Select, MenuItem, TextField } from '@material-ui/core';
import './report.css'
import NpsRating from "../../NPS";
const useStyles = makeStyles((theme) =>
    createStyles({
        paper: {
            width: "100%",
        },
        centerIt: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        fontWeight: {
            fontWeight: "bold",
        },
        textCenter: {
            textAlign: "center",
        },
        endIt: {
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
        },
        belowIt: {
            display: "flex",
            alignItems: "flex-end",
        },
        line: {
            borderBottom: "5px solid red",
            marginTop: "5px",
            width: "90%",
        },
        inputFiled: {
            outline: "none"
        },
        tableCell: {
            padding: 2,
            height: 50,
        },
        input: {
            padding: "1px",
        },
       
    })
);


interface Props {
    reportListParameter: any;
    getReportTemplateParameter: any;
    bookingId: any;
    reportData: any;
    getNbsData: any;
    fetchNbsdata: any;
    getBookingByNbsForm: any;
    bookingnbsform: any;
    createNewReport: any;
    getUpdatedCustomerReportData: any;
    updatedReportData: any;
    updateReport: any
    resetBookingData: any;
}
const NbsReport: React.FC<Props> = ({
    getReportTemplateParameter,
    reportListParameter,
    bookingId,
    reportData,
    getNbsData,
    fetchNbsdata,
    getBookingByNbsForm,
    bookingnbsform,
    createNewReport,
    getUpdatedCustomerReportData,
    updatedReportData,
    updateReport,
    resetBookingData,
}) => {
    const componentRef = useRef<any>(null);
    const timer = useRef<any>(0);
    const { id } = useParams<{ id: string }>();
    const classes = useStyles();
    const navigate = useNavigate();
    const { firstP, secondP, thirdP } = useParams<any>();
    const [status, setStatus] = useState<string>(reportListParameter?.status);
    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
    const reactToPrintContent = React.useCallback(() => {
        return componentRef.current;
    }, [componentRef.current]);
    const [startDateTime, setStartDateTime] = useState({})
    const [uuid, setUuid] = useState<any>("")

    const baseTableValues = [
        { id: "g6pd", disorder: "G6PD Deficiency", parameter: "Glucose-6-Phosphate Dehydrogenase Enzyme Activity", paramter_name:"Glucose_6_phosphate_dehydrogenase_enzyme_activity", value: 5.7, unit: "U/gHb", min: 2, max: "", remark: "Normal" },
        { id: "cah", disorder: "Congenital Adrenal Hyperplasia (CAH)", parameter: "17-Hydroxy Progesterone (17-OHP)", paramter_name:"17_Hyrdoxy_progesterone_17_OHP", value: 19.5, unit: "ng/mL", min: "", max: 20, remark: "Normal" },
        { id: "cf", disorder: "Cystic Fibrosis (CF)", parameter: "Immunoreactive Trypsinogen (IRT)", paramter_name:"Immunoreactive_trypsinogen_IRT", value: 18, unit: "µg/L", min: "", max: 110, remark: "Normal" },
        { id: "gal", disorder: "Galactosemia (GAL)", parameter: "Total Galactose (TGAL)", paramter_name:"Total_galactose_TGAL", value: 0.01, unit: "mg/dL", min: "", max: 20, remark: "Normal" },
        { id: "ch", disorder: "Congenital Hypothyroidism (CH)", parameter: "TSH (Thyroid Stimulating Hormone)", paramter_name:"TSH_thyroid_stimulating_hormone", value: 2.1, unit: "mIU/L", min: "", max: 10, remark: "Normal" },
        { id: "biotin", disorder: "Biotinidase Deficiency", parameter: "Biotinidase (BIOT) Enzyme Activity", paramter_name:"Biotinidase_BIOT_enzyme_activity", value: 154.3, unit: "U", min: 40, max: "", remark: "Normal" },
        { id: "pku", disorder: "Phenylketonuria (PKU)", parameter: "Phenylalanine", paramter_name:"Phenylalanine", value: 1.4, unit: "mg/100ml", min: "", max: 2, remark: "Normal" },
    ];

    const [tableValues, setTableValues] = useState(baseTableValues);

    const intialItems = [
        "Neonatal G6PD test is designed for the quantitative determination of glucose-6-phosphate dehydrogenase activity in blood. G6PD deficiency is the most common human enzyme deficiency, resulting in a condition called Hemolytic Anemia. In some cases, neonatal jaundice occurs, which is severe enough to cause death or permanent neurologic damage. Identification of the deficiency therefore becomes critical for prevention of acute episodes, precipitated by certain oxidative drugs, fava beans, or infections.",
        "Neonatal 17-OH-Progesterone test enables the quantification of 17-OH-Progestrone steroid present in blood. Deficiency of the enzyme 21-hydroxylase is the most frequent cause of Congenital Adrenal Hyperplasia (CAH), and results in high level of circulating 17-OH-Progesterone. Symptoms of CAH range from hypoglycemia, water loss, salt-losing tendency to masculinization in varying combinations, and can be effectively treated by steroid substitution therapy if detected in early stage of life.",
        "This Neonatal IRT assay is intended for the quantitative determination of human Immunoreactive Trypsinogen (IRT) in blood as a primary test for screening of babies for Cystic Fibrosis (CF). CF is an autosomal recessive disorder affecting the lungs, pancreas, intestine, and liver, and is characterized by manifestations of chronic sinopulmonary disease and exocrine pancreatic insufficiency. Early diagnosis in newborns is essential for institution of effective therapeutic interventions.",
        "Neonatal Galactose is intended for the quantitative determination of the total galactose in blood. Galactosemia is an inherited metabolic abnormality comprising distinctive clinical entities of the galactose pathway defects. Cardinal features are hepatomegaly, cataracts, and mental retardation. Early identification in neonates enables early and appropriate interventions to help prevent permanent damage.",
        "Neonatal hTSH enables the quantitative determination of human thyrotropin (hTSH) in blood. It is a primary test for screening of babies for Congenital Hypothyroidism (CH), characterized by decreased levels of thyroid hormones: thyroxine (T4) and triiodothyronine (T3). The condition, if undiagnosed and untreated, leads to severe mental retardation, as well as to growth and developmental disturbances. Due to the availability of effective replacement therapy, screening for CH in newborns is recommended to facilitate early intervention where appropriate.",
        "Neonatal Biotinidase determines human Biotinidase enzyme activity in blood. Profound Biotinidase deficiency can lead to a decrease in biotin availability and if untreated, is associated with neurologic and cutaneous consequences, including development delays, seizures, ataxia, hypotonia, metabolic compromises etc. and may be life threatening. Biotin supplementation can prevent the development of symptoms of biotinidase deficiency, which makes early diagnosis crucial.",
        "Neonatal Phenylalanine assay is designed for the quantitative determination of phenylalanine concentration in blood. Classical phenylketonuria (PKU) is characterized by the accumulation of phenylalanine and its toxic metabolites in brain tissue during the neonatal period, that causes metabolic encephalopathy. PKU when left undiagnosed in early neonatal period and untreated by diet low in phenylalanine causes irreversible damage, and hence the need for early diagnosis and treatment initiation.",
        ];

   
    useEffect(() => {
        if (
            reportListParameter &&
            reportListParameter?.report_types &&
            reportListParameter?.report_types.length > 0 
        ) {
            const synced: any[] = [];

            baseTableValues.forEach((row) => {
                const match = reportListParameter.report_types.find(
                    (p: any) => p.parameter_name === row.paramter_name
                );

                const paramValue =
                    match && match.parameter_value !== null && match.parameter_value !== undefined && 
                        match.parameter_value !== "null"
                        ? match.parameter_value
                        : "null";

                // In edit mode, treat empty backend values as deleted for UI
                const isDeleted =
                    thirdP === "edit" && (paramValue === "" || paramValue === null || paramValue === undefined || paramValue === "null");

                // Load remark from corresponding *_result parameter if present
                const remarkMatch = reportListParameter.report_types.find(
                    (p: any) => p.parameter_name === `${row.paramter_name}_result`
                );

                let remarkValue: any = row.remark;
                if (isDeleted) {
                    // deleted parameters should have remark "null" as well
                    remarkValue = "null";
                } else if (remarkMatch) {
                    const rv = remarkMatch.parameter_value;
                    remarkValue =
                        rv === undefined || rv === null || rv === "" || rv === "null"
                            ? row.remark
                            : rv;
                }

                synced.push({
                    ...row,
                    value: paramValue,
                    remark: remarkValue,
                    isDeleted,
                });
            });

            setTableValues(synced.length > 0 ? synced : baseTableValues);
        } else {
            setTableValues(baseTableValues);
        }
    }, [reportListParameter, thirdP]);

    console.log(tableValues,"idsocdsocisdncoi")

    const reactToPrintTrigger = React.useCallback(() => {
        return <button style={{ marginLeft: "10px", background: "#b02613", color: "white" }}>Print Report</button>;
    }, []);

    useEffect(() => {
        if (thirdP !== "add") {
            getUpdatedCustomerReportData(`booking_id=${firstP}&template_id=${secondP}`)
        } else {
            getReportTemplateParameter(`booking_id=${firstP}&template_id=${secondP}`);
        }
        // getNbsData(`type=booking&bid=${firstP}`);
        getBookingByNbsForm(`${firstP}`);
    }, [])

    const [packages, setPackages] = useState<any>([])
    useEffect(() => {
        const data: any = []
        if (reportListParameter && reportListParameter?.booking && reportListParameter?.booking?.length > 0 && reportListParameter?.booking?.map((list1: any) => {
            return (
                list1?.packages && list1?.packages.length > 0 && list1?.packages?.map((list: any) => {
                    data?.push({ ...list });

                })
            )
        }))
            setPackages(data);
        if (data && data.length > 0) {
            getNbsData(`type=booking&bid=${firstP}&test_code=${data[0].code}`);
        }
    }, [reportListParameter])

    const [nbsReport, setNbsReport] = useState<any>([])
    useEffect(() => {
        const data: any = []
        if (reportListParameter && reportListParameter?.booking && reportListParameter?.booking.length > 0) {
            reportListParameter?.booking?.map((list: any) => {
                data?.push({ ...list });
            })
        }

        setNbsReport(data);
    }, [reportListParameter])

    useEffect(() => {
        if (nbsReport && nbsReport.length > 0) {
            setUuid(nbsReport[0].uuid);
        }
    }, [nbsReport])

    // Editable header fields
    const [babyName, setBabyName] = useState<string>("");
    const [gender, setGender] = useState<string>("");
    const [hospitalName, setHospitalName] = useState<string>("");
    const [referredBy, setReferredBy] = useState<string>("");
   

    useEffect(() => {
        const booking = nbsReport[0];
        if (booking) {
            setBabyName(booking?.customer_name || "");
            setGender(booking?.customer_gender || "");
            setHospitalName(booking?.center?.name || "");
            setReferredBy(booking?.doctor_name || "");
          
        }
    }, [nbsReport]);

    const [nbsData, setnbsData] = useState<any>([])
    useEffect(() => {
        const nbsData: any = [];
        if (bookingnbsform && bookingnbsform?.length > 0) {
            bookingnbsform?.map((list: any) => {
                nbsData.push({
                    ...list
                })
            })
        }
        setnbsData(nbsData);
    }, [bookingnbsform]);

    const [itdoseData, setidDoseData] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (fetchNbsdata && fetchNbsdata?.length > 0) {
            fetchNbsdata?.map((list: any) => {
                data.push({
                    ...list
                })
            })
        }
        setidDoseData(data);

    }, [fetchNbsdata])

    // Report_Summary
    const [reportSummary, setReportSummary] = useState<any>([])
    useEffect(() => {
        const data: any = []
        if (reportListParameter && reportListParameter?.report_summary && reportListParameter?.report_summary.length > 0) {
            reportListParameter?.report_summary?.map((list: any) => {
                data?.push({ ...list });
            })
        }
        setReportSummary(data);
    }, [reportListParameter])

    const updateReportSummary = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...reportSummary]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setReportSummary(storeData);
    }

    // Hospital Id

    const [HospitalId, setHospitalId] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.Hospital_Id

            &&
            reportListParameter?.Hospital_Id


                .length > 0
        ) {
            reportListParameter?.Hospital_Id


                ?.map((list: any) => {
                    data?.push({ ...list });
                });
        }
        setHospitalId(data);
    }, [reportListParameter]);

    const updateHospitalID = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...HospitalId]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setHospitalId(storeData);
    }
    // Recommendadtions

    const [recommendadtion, setRecommendadtion] = useState<any>([])
    useEffect(() => {
        const data: any = []
        if (reportListParameter && reportListParameter?.recommendations && reportListParameter?.recommendations.length > 0) {
            reportListParameter?.recommendations?.map((list: any) => {
                data?.push({ ...list });
            })
        }
        setRecommendadtion(data);
    }, [reportListParameter])

    const updateRecommendations = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...recommendadtion]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setRecommendadtion(storeData);
    }

    // nbsReport Type
    const [nbsReportType, setNbsReportType] = useState<any>([])
    useEffect(() => {
        const data: any = []
        if (reportListParameter && reportListParameter?.report_types && reportListParameter?.report_types.length > 0) {
            reportListParameter?.report_types?.map((list: any) => {
                // Only keep checkbox-type report types here (Version No, Revision Report, etc.).
                // Result free_text parameters (Glucose_6_..., Phenylalanine, etc.) are handled via reportResult.
                if (list?.parameter_type === "checkbox") {
                    data?.push({ ...list });
                }
            })
        }
        setNbsReportType(data);
    }, [reportListParameter])

    const updateItemValue = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...nbsReportType]
        let newItem = object;
        switch (key) {
            case "checkbox":
                newItem.parameter_value = value === true ? "true" : "false";
                break;
        }
        storeData[index] = newItem;
        setNbsReportType(storeData);
    }

    //update remarks
    const [nbsInterpretation, setNbsInterpretation] = useState<any>([])
    useEffect(() => {
        const data: any = []
        if (reportListParameter && reportListParameter?.interpretation && reportListParameter?.interpretation.length > 0) {
            reportListParameter?.interpretation?.map((list: any) => {
                data?.push({ ...list });
            })
        }
        setNbsInterpretation(data);
    }, [reportListParameter])

    const [nbsDoctorType, setNbsDoctorType] = useState<any>([])
    useEffect(() => {
        const data: any = []
        if (reportListParameter && reportListParameter?.doctor_list && reportListParameter?.doctor_list.length > 0) {
            reportListParameter?.doctor_list?.map((list: any) => {
                data?.push({ ...list });
            })
        }
        setNbsDoctorType(data);
    }, [reportListParameter])

    const updateDoctorListValue = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...nbsDoctorType]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value
                break;
        }
        storeData[index] = newItem;
        setNbsDoctorType(storeData);
    }

    const submitData = async (e: any) => {
        e.preventDefault();

        let storeData: any = [];

        if (nbsInterpretation.length > 0) {
            nbsInterpretation?.map((list: any) => {
                storeData.push({
                    ...list,
                })
            })
        }

        if (nbsDoctorType.length > 0) {
            nbsDoctorType?.map((list: any) => {
                storeData.push({
                    ...list
                })
            })
        }

        if (HospitalId.length > 0) {
            HospitalId?.map((list: any) => {
                storeData.push({
                    ...list
                })
            })
        }


        if (recommendadtion.length > 0) {
            recommendadtion?.map((list: any) => {
                storeData.push({
                    ...list
                })
            })
        }

        if (reportSummary.length > 0) {
            reportSummary?.map((list: any) => {
                storeData.push({
                    ...list
                })
            })
        }

        // push all report_types parameters, updating their parameter_value from UI state
        if (
            reportListParameter &&
            reportListParameter?.report_types &&
            reportListParameter?.report_types.length > 0
        ) {
            reportListParameter.report_types.forEach((item: any) => {
                // For result parameters (free_text), take value from tableValues
                const resultMatch = tableValues.find(
                    (row: any) => row.paramter_name === item.parameter_name
                );

                // For checkbox parameters (Version No, Revision Report, etc.), take value from nbsReportType
                const checkboxMatch = nbsReportType.find(
                    (cb: any) => cb.id === item.id
                );

                let paramValue = item.parameter_value;

                if (item.parameter_type === "checkbox" && checkboxMatch) {
                    // checkbox values come directly from nbsReportType ("true"/"false")
                    paramValue = checkboxMatch.parameter_value;

                } else if (item.parameter_name && item.parameter_name.endsWith("_result")) {
                    // remark parameters: use the calculated remark from min/max (getRemark)
                    const baseName = item.parameter_name.replace(/_result$/, "");
                    const remarkRow = tableValues.find(
                        (row: any) => row.paramter_name === baseName
                    );
                    const r = remarkRow ? getRemark(remarkRow) : undefined;
                    paramValue =
                        r === undefined || r === null || r === "" || r === "null" || r === "-"
                            ? "null"
                            : r;

                } else if (resultMatch) {
                    // numeric/text result parameters: prefer current table value, but normalize empty to "null"
                    const v = resultMatch.value;
                    paramValue =
                        v === undefined || v === null || v === "" || v === "null"
                            ? "null"
                            : v;

                } else {
                    // no table row match: normalize backend value as well
                    const v = item.parameter_value;
                    paramValue =
                        v === undefined || v === null || v === "" || v === "null"
                            ? "null"
                            : v;
                }

                storeData.push({
                    ...item,
                    parameter_value: paramValue,
                });
            });
        }
        const reportData = {
            template_id: secondP,
            booking_id: firstP,
            case_id: firstP,
            status: status,
            template_parameter: storeData,
            baby_name: babyName,
            gender: gender,
            hospital_name: hospitalName,
            doctor_name: referredBy,
        };
        const reportEditData = {
            template_id: secondP,
            booking_id: firstP,
            case_id: firstP,
            status: status,
            template_parameter: storeData,
            customer_name: babyName,
            customer_gender: gender,
            hospital_name: hospitalName,
            doctor_name: referredBy,
        };
        if (thirdP === "add") {
            await createNewReport(reportData);
            navigate('/dashboard/la');
        } else if (thirdP === "edit") {
            await updateReport(reportListParameter?.id, reportEditData);
        }
    }

    const [barcodeValue, setBarcodeValue] = React.useState(
        JSON.stringify({
            date_time: moment().format(),
            patient_name: reportListParameter?.patient_name,
        })
    );

    const handleClick = (event: any) => {
        setBarcodeValue(
            JSON.stringify({
                date_time: moment().format(),
                patient_name: reportListParameter?.patient_name,
            })
        );
        setAnchorEl(event.currentTarget);
    };
    //baby age calculation using collection_date from nbsReport[0] and dob + birth_time
    let birthYears = 0;
    let birthMonths = 0;
    let birthDays = 0;
    let birthHours = 0;

    if (nbsReport && nbsReport[0]?.collection_date && nbsReport[0]?.dob && nbsData && nbsData[0]?.birth_time) {
        const collectionMoment = moment(nbsReport[0]?.collection_date);
        const dobMoment = moment(`${nbsReport[0]?.dob} ${nbsData[0]?.birth_time}`, "YYYY-MM-DD HH:mm");

        if (collectionMoment.isValid() && dobMoment.isValid()) {
            const diff = moment.duration(collectionMoment.diff(dobMoment));
            birthYears = diff.years();
            birthMonths = diff.months();
            birthDays = diff.days();
            birthHours = diff.hours();
        }
    }

    useEffect(() => {
        resetBookingData();
    }, [])

    const [uhid, setuhid] = useState<any>([]);
     const [tempCode, setTempCode] = useState<any>([]);
    useEffect(() => {
        setuhid(reportListParameter?.uhid)
        setTempCode(reportListParameter?.template_code)
    }, [reportListParameter])
    const documentTitle = `${nbsReport[0]?.pk}_${nbsReport[0]?.customer_name?.replace(/[\/\s-]/g, '_')}_${uhid}_${tempCode}`;

    const deleteRow = (id: any) => {
        // Mark row as deleted for UI and set both value and remark to "null";
        // payload will then send "null" for result and *_result parameters.
        setTableValues(prev =>
            prev.map((row: any) =>
                row.id === id
                    ? { ...row, value: "null", remark: "null", isDeleted: true }
                    : row
            )
        );
    };

    const getRemark = (row:any) => {
        const value = Number(row.value);
        const min = row.min !== "" ? Number(row.min) : null;
        const max = row.max !== "" ? Number(row.max) : null;

        if (min !== null && max !== null) {
            if (value <= min) return "Low";
            if (value > max) return "High";
            return "Normal";
        }

        if (min !== null) {
            return value <= min ? "Low" : "Normal";
        }

        if (max !== null) {
            return value > max ? "High" : "Normal";
        }

        return "-";
        };


    

    return (
        <div style={{ margin: "55px auto" }}>
            <div>
                <div style={{ height: "20px", }}>
                    <div>
                        {thirdP !== "add" && (
                            <ReactToPrint
                                content={reactToPrintContent}
                                trigger={reactToPrintTrigger}
                                documentTitle={documentTitle}
                            />
                        )}
                    </div>
                </div>
                <div style={{ width: "200px", marginLeft: "780px" }}>
                    <TextField
                        id="outlined-select-currency"
                        select
                        variant="outlined"
                        fullWidth
                        className={classes.input}
                        label="Select Report Type"
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                        style={{ height: "30px" }}
                    >
                        <MenuItem value={"Draft"}>Draft</MenuItem>
                        <MenuItem value={"Editable"}>Editable</MenuItem>
                        <MenuItem value={"Approved"}>Approved</MenuItem>
                        <MenuItem value={"Hold"}>Hold</MenuItem>
                        <MenuItem value={"Cancelled"}>Cancelled</MenuItem>
                    </TextField>
                </div>
                <div style={{ height: "20px", marginLeft: "1000px", marginBottom: "20px" }}>
                    <div>
                        <button style={{ background: "#142c96", color: "white", width: "100px", height: "40px", marginTop: "-10px" }} disabled={status === ""} onClick={submitData}>Submit</button>
                    </div>
                </div>
            </div>
            <div
                id="PAGE"
                ref={componentRef}
                style={{
                    width: 1122,
                    background: "#fff",

                }}
            >
                {/* header section */}
                <div className="nbs-page-header">
                    <div style={{ padding: "20px" }}>
                        <div
                            style={{
                                width: "100%",
                                display: "flex",
                                background: "#fff",

                            }}
                        >
                            <div style={{ width: "80%", padding: 15 }}>
                                <div style={{ color: "black", fontWeight: "bold", fontSize: "25px", textAlign: "left" }}>
                                    LABORATORY REPORT
                                </div>
                            </div>
                            <div style={{ width: "20%", textAlign: "left", padding: 15 }}>
                                <h3>
                                    <img src={logo} alt="logo" style={{ width: "180px" }} />
                                </h3>
                            </div>
                        </div>
                    </div>
                </div>
                {/* header section closed */}
                {/* patient section details */}
                <div style={{ padding: "20" }} className="bodyPage">

                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            background: "#fff",

                        }}
                    >
                        <div style={{ width: "100%", textAlign: "center" }}>
                            <div style={{ color: "#b52155", fontWeight: "bold", fontSize: "25px" }}>
                                NEWBORN SCREENING PROFILE
                            </div>
                        </div>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px", textAlign: "start" }}>
                        <div style={{ width: "35%", marginLeft: 8 }}>
                            Baby Name:&nbsp;&nbsp;
                            {nbsReport[0]?.designation}&nbsp;
                            <input
                                className="input"
                                style={{ border: "none", width: "65%", textAlign: "start", appearance: "none" }}
                                type="text"
                                value={babyName}
                                onChange={(e) => setBabyName(e.target.value)}
                            />
                        </div>
                        <div style={{ width: "27%", marginLeft: 8 }}>
                            Gender:&nbsp;&nbsp;
                            <input
                                className="input"
                                style={{ border: "none", width: "65%", textAlign: "start", appearance: "none" }}
                                type="text"
                                value={gender}
                                onChange={(e) => setGender(e.target.value)}
                            />
                        </div>
                        <div style={{ width: "38%", marginLeft: 8 }}>Baby Weight(Kg):&nbsp;&nbsp;{nbsData[0]?.baby_weight || ""}</div>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px", textAlign: "start" }}>
                        <div style={{ width: "35%", marginLeft: 8 }}>Gestational Age:&nbsp;&nbsp;W:{nbsData[0]?.gestational_age_weeks}&nbsp;D:{nbsData[0]?.gestational_age_days}</div>
                        <div style={{ width: "27%", marginLeft: 8 }}>Date Of Birth:&nbsp;&nbsp;
                           
                            {nbsReport[0]?.dob}
                        </div>
                        <div style={{ width: "38%", marginLeft: 8 }}>Time Of Birth(24 hrs):{nbsData[0]?.birth_time}</div>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px", textAlign: "start" }}>
                        <div style={{ width: "35%", marginLeft: 8 }}>Collection Date:&nbsp;&nbsp;{nbsReport[0]?.collection_date || ""}</div>
                        <div style={{ width: "27%", marginLeft: 8 }}>Collection Time:&nbsp;&nbsp;{nbsReport[0]?.collection_slot?.split(" ")?.slice(1)?.join(" ") || ""}</div>
                        <div style={{ width: "38%", marginLeft: 8 }}>Age:&nbsp;&nbsp;{birthYears}Y,{birthMonths}M,{birthDays}D,{birthHours}H</div>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px", textAlign: "start" }}>
                        <div style={{ width: "35%", marginLeft: 8 }}>Blood Transfusion Date :&nbsp;&nbsp;{nbsData[0]?.transfusion_date ? nbsData[0]?.transfusion_date : "NO"}</div>
                        <div style={{ width: "27%", marginLeft: 8 }}>Special Feed:&nbsp;&nbsp;{nbsData[0]?.type_of_feed}</div>
                        <div style={{ width: "38%", marginLeft: 8 }}>Report Date & Time:&nbsp;&nbsp;{moment?.tz(Date.now(), "Asia/Kolkata")?.format("YYYY-MM-DD,HH:mm:ss")}</div>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px", textAlign: "start" }}>
                        <div style={{ width: "35%", marginLeft: 8 }}>
                            Referred By : {referredBy}                      
                        </div>
                        <div style={{ width: "27%", marginLeft: 8 }}>Sample Type:&nbsp;&nbsp; {nbsReport[0]?.sample_type}</div>
                        <div style={{ width: "38%", marginLeft: 8 }}>Test/Package:&nbsp;&nbsp;{nbsReport[0]?.packages[0]?.name}</div>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px", textAlign: "start" }}>
                        <div style={{ width: "35%", marginLeft: 8 }}>Barcode No:&nbsp;&nbsp;{nbsReport[0]?.barcode}</div>
                        <div style={{ width: "27%", marginLeft: 8 }}>Booking No:&nbsp;&nbsp;{nbsReport[0]?.pk}</div>
                        <div style={{ width: "38%", marginLeft: 8 }}>Received Date & Time:&nbsp;{nbsReport?.[0]?.pickup_date},{nbsReport?.[0]?.pickup_time?.slice(0, nbsReport[0]?.pickup_time?.indexOf("."))}</div>
                    </div>
                    <div style={{ width: "100%", display: "flex", margin: "10px 0px", textAlign: "start" }}>
                        <div style={{ width: "38%", marginLeft: 8 }}>
                            Hospital Name:&nbsp;&nbsp; {hospitalName}
                            
                        </div>
                        {nbsReport[0]?.center?.name && nbsReport[0]?.center?.name.toUpperCase().includes("ARMC") ? (
                            <div style={{ width: "27%", display: "flex", marginLeft: 8 }}>
                                {HospitalId?.map((list: any, index: number) => {
                                    return (
                                        <div style={{ width: "100%", marginLeft: 8 }}>
                                            Hospital ID :
                                            <input
                                                key={list?.id}
                                                style={{ border: "none", width: "70%", background: "none", }}
                                                value={list?.parameter_value}
                                                onChange={(e: any) => updateHospitalID(list?.id, e.target.value, index, "free_text", list)}
                                            />
                                        </div>
                                    );
                                })}

                            </div>
                        ) : null}
                    </div>

                </div>
                {/* patient details section closed */}

                {/* reslts value */}
                <div style={{ padding: "20" }} className="nbs-merginLeft">
                    <div style={{ color: "#fff", marginTop: "25px", fontWeight: "bold", fontSize: "20px", borderRadius: "0px 10px", backgroundColor: "#2b0980", width: "270px", textAlign: "center", borderRight: "4px solid #e00241" }}>
                        RESULT
                    </div>
                    <div style={{ width: "100%", textAlign: "left" }}>
                       <TableContainer style={{ borderRadius: "8px", marginTop: "5px" }}>
  <Table stickyHeader aria-label="simple">
    <TableHead style={{ backgroundColor: "#b3b3b3" }}>
      <TableRow>
        <TableCell align="left" style={{ backgroundColor: "rgb(28 35 131)", color: "#fff" }}>Disorder</TableCell>
        <TableCell align="left" style={{ backgroundColor: "rgb(28 35 131)", color: "#fff" }}>Parameter</TableCell>
        <TableCell align="center" style={{ backgroundColor: "rgb(28 35 131)", color: "#fff" }}>Method</TableCell>
        <TableCell align="center" style={{ backgroundColor: "rgb(28 35 131)", color: "#fff" }}>Results</TableCell>
        <TableCell align="center" style={{ backgroundColor: "rgb(28 35 131)", color: "#fff" }}>Value</TableCell>
        <TableCell align="center" style={{ backgroundColor: "rgb(28 35 131)", color: "#fff" }}>Unit</TableCell>
        <TableCell align="center" style={{ backgroundColor: "rgb(28 35 131)", color: "#fff" }}>Reference Interval</TableCell>
        <TableCell align="center" style={{ backgroundColor: "rgb(28 35 131)", color: "#fff" }}>Remarks</TableCell>
         <TableCell className="hide-print" align="center" style={{ backgroundColor: "rgb(28 35 131)", color: "#fff" }}>Delete Row</TableCell>
      </TableRow>
    </TableHead>

   <TableBody>
  {(thirdP === "edit"
      ? tableValues.filter(
            (row: any) =>
                !row.isDeleted &&
                row.value !== "" &&
                row.value !== null &&
                row.value !== undefined && row.value !== "null"
        )
      : tableValues.filter((row: any) => !row.isDeleted)
    ).map((row, rowIndex) => {
    return (<TableRow key={row.id}>
      <TableCell>{row.disorder}</TableCell>
      <TableCell>{row.parameter}</TableCell>
      <TableCell align="center">-</TableCell>

      {/* Results: progress bar */}
      <TableCell align="center">
        <progress
          className={getRemark(row) !== "Normal" ? "result-bar abnormal" : "result-bar normal"}
          value={row?.value}
          max={row.max || row.min}
          style={{
            height: 8,
            width: "120%",
          }}
        />
      </TableCell>

      {/* Editable Value */}
      <TableCell align="center">
        <div className="hide-print">
            <input
          type="number"
          className="nbs-number"
          value={row.value || 0}
          onChange={(e) => {
            const inputVal = e.target.value;
            const safeValue = inputVal === "" ? 0 : Number(inputVal);
            setTableValues(
              tableValues.map((r) =>
                r.id === row.id ? { ...r, value: safeValue } : r
              )
            );
          }}
          onKeyDown={(e) => {
                if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                e.preventDefault();         
                }
            }}
         onWheel={(e) => {
                e.currentTarget.blur();        
            }}
          style={{ width: 80, padding: 4 }}
        />
        </div>
        <div className="showPrint">{row?.value}</div>
        
      </TableCell>

      {/* Unit */}
      <TableCell align="left">{row.unit}</TableCell>

      {/* Interval */}
      <TableCell align="left">
        {row.max && <>Normal &lt;{row.max}<br />High &gt;{row.max}</>}
        {row.min && <>Normal &gt;{row.min}<br />Deficient &lt;{row.min}</>}
      </TableCell>

      <TableCell align="left">

        {getRemark(row)}
      </TableCell>

      {/* Delete Button */}
      <TableCell className="hide-print" align="center">
        <button
          style={{
            padding: "4px 10px",
            background: "red",
            color: "#fff",
            border: "none",
            borderRadius: 4,
            cursor: "pointer"
          }}
          onClick={() => deleteRow(row.id)}
        >
          Delete
        </button>
      </TableCell>
    </TableRow>)
})}
</TableBody>

  </Table>
</TableContainer>

                    </div>
                </div>
                {/* reslts value closed */}

                <div style={{ padding: "20" }} className="nbs-merginLeft">
                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            background: "#fff",
                            padding: "20px"

                        }}
                    >
                        {nbsReportType?.map((list: any, index: number) => {

                            return (<div style={{ width: "22%" }}>
                                <h5>
                                    {list?.parameter_name}<input type="checkbox" style={{ marginLeft: "10px", width: "30px", height: "16px", }} checked={list?.parameter_value === "true" ? true : false}
                                        onChange={(e: any) => {
                                            updateItemValue(list?.id, e.target.checked, index, "checkbox", list)
                                        }} />
                                </h5>
                            </div>)
                        })}
                    </div>
                </div>
                <div style={{ padding: "20" }} className="nbs-merginLeft">
                    <div style={{ color: "#fff", fontWeight: "bold", fontSize: "18px", borderRadius: "0px 10px", backgroundColor: "#2b0980", width: "270px", textAlign: "center", borderRight: "4px solid #e00241" }}>
                        METHODOLOGY
                    </div>
                    <div style={{ width: "90%", marginLeft: "10px", marginTop: "10px" }}>
                        <h6>FEIA-Flurometric Enzyme Immunoassay</h6>
                    </div>
                </div>

                <div style={{ padding: "20", marginTop: "5px" }} className="nbs-merginLeft">
                    <div style={{ color: "#fff", fontWeight: "bold", fontSize: "16px", borderRadius: "0px 10px", backgroundColor: "#2b0980", width: "270px", textAlign: "center", borderRight: "4px solid #e00241" }}>
                        REPORTS SUMMARY
                    </div>
                    {reportSummary?.map((list: any, index: number) => {
                        return (
                            <div style={{ width: "90%", marginLeft: "10px" }}>
                                <textarea
                                    rows={6}
                                    cols={155}
                                    onChange={(e) => updateReportSummary(list?.id, e.target.value, index, "free_text", list)}
                                    style={{ border: "none", fontSize: "14px", resize: "none" }}
                                    value={list?.parameter_value}
                                />
                            </div>
                        )
                    })
                    }

                </div>
                
                        <div
                        aria-hidden
                        style={{
                            height: Math.max(
                            0,
                            (
                                baseTableValues.length -
                                (
                                thirdP === "edit"
                                    ? tableValues.filter(
                                        (row: any) =>
                                        !row.isDeleted &&
                                        row.value !== "" &&
                                        row.value !== null &&
                                        row.value !== undefined &&
                                        row.value !== "null"
                                    ).length
                                    : tableValues.filter((row: any) => !row.isDeleted).length
                                )
                            ) * 56 // px per missing row; tune if needed (50–64)
                            ),
                            visibility: "hidden",
                        }}
                        />

                

                 <div style={{ padding: "80", }}>
                    <div style={{ color: "#fff", fontWeight: "bold", fontSize: "20px", borderRadius: "0px 10px", backgroundColor: "#2b0980", width: "270px", textAlign: "center", borderRight: "4px solid #e00241" }}>

                    </div>
                    <div style={{ width: "90%", marginLeft: "10px" }} className="tablecontent">
                        {/* <h6>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna</h6> */}.
                    </div>
                    <div style={{ width: "90%", marginLeft: "10px" }} className="tablecontent3">
                        {/* <h6>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna</h6> */}.
                    </div>
                </div>
                
                
                <div style={{ padding: "20", marginTop: "10px" }} className="nbs-position">
                    <div style={{ color: "#fff", fontSize: "16px", fontWeight: "bold", borderRadius: "0px 10px", backgroundColor: "#2b0980", width: "270px", textAlign: "center", borderRight: "4px solid #e00241" }}>
                        RECOMMENDATION
                    </div>

                    {recommendadtion?.map((list: any, index: number) => {
                        return (
                            <div style={{ width: "90%", marginLeft: "10px" }}>
                                <textarea
                                    rows={4}
                                    cols={155}
                                    onChange={(e) => updateRecommendations(list?.id, e.target.value, index, "free_text", list)}
                                    style={{ border: "none", fontSize: "14px", resize: "none" }}
                                    value={list?.parameter_value}
                                />
                            </div>
                        )
                    })
                    }
                </div>
                <div>
                    {fetchNbsdata && fetchNbsdata?.length <= 1 && fetchNbsdata?.map((data: any, index: any) => data?.name === "17-Hydroxy Progesterone (17-OHP)~Congenital Adrenal Hyperplasia (CAH)" ?
                        " " : <div className="nbr" style={{ marginTop: "0px" }}>.</div>)}
                    {fetchNbsdata && fetchNbsdata?.length <= 1 && fetchNbsdata?.map((data: any, index: any) => data?.name === "TSH (Thyroid Stimulating Hormone)~Congenital Hypothyroidism (CH)" ?
                        " " : <div className="nbr" style={{ marginTop: "5px" }}>.</div>)}
                    {fetchNbsdata && fetchNbsdata?.length <= 1 && fetchNbsdata?.map((data: any, index: any) => data?.name === "Glucose-6-Phosphate Dehydrogenase Enzyme Activity~G6PD Deficiency" ?
                        " " : <div className="nbr" style={{ marginTop: "5px" }}>.</div>)}
                    {fetchNbsdata && fetchNbsdata?.length <= 1 && fetchNbsdata?.map((data: any, index: any) => data?.name === "Biotinidase (BIOT) Enzyme Activity~Biotinidase Deficiency" ?
                        " " : <div className="nbr" style={{ marginTop: "10px" }}>.</div>)}
                    {fetchNbsdata && fetchNbsdata?.length <= 1 && fetchNbsdata?.map((data: any, index: any) => data?.name === "Total Galactose (TGAL)~Galactosemia (GAL)" ?
                        " " : <div className="nbr" style={{ marginTop: "20px" }}>.</div>)}
                    {fetchNbsdata && fetchNbsdata?.length <= 1 && fetchNbsdata?.map((data: any, index: any) => data?.name === "Phenylalanine~Phenylketonuria (PKU)" ?
                        " " : <div className="nbr" style={{ marginTop: "30px" }}>.</div>)}
                    {fetchNbsdata && fetchNbsdata?.length <= 1 && fetchNbsdata?.map((data: any, index: any) => data?.name === "Immunoreactive Trypsinogen (IRT)~Cystic Fibrosis (CP)" ?
                        " " : <div className="nbr" style={{ marginTop: "40px" }}>.</div>)}
                </div>
               

                {/* interpretations */}
                <div style={{ padding: "20", marginTop: "5px" }} className="nbs-merginLeft">
                    <div style={{ color: "#fff", fontWeight: "bold", fontSize: "20px", borderRadius: "0px 10px", backgroundColor: "#2b0980", width: "270px", height: "25px", textAlign: "center", borderRight: "4px solid #e00241", }}>
                        INTERPRETATIONS
                    </div>
                    <ul style={{ marginTop: "10px" }}>
                        {(thirdP === "edit"
                            ? tableValues.filter(
                                  (row: any) =>
                                      !row.isDeleted &&
                                      row.value !== "" &&
                                      row.value !== null &&
                                      row.value !== undefined && row.value !== "null"
                              )
                            : tableValues.filter((row: any) => !row.isDeleted)
                          ).map((row: any) => {
                            const baseIndex = baseTableValues.findIndex(
                                (b: any) => b.paramter_name === row.paramter_name
                            );
                            const text = intialItems[baseIndex];
                            if (!text) return null;
                            return (
                                <li key={row.id}>{text}</li>
                            );
                          })}
                    </ul>
                </div>
                {/* second page  starting */}
                <div style={{ padding: "20" }} className="nbs-merginLeft">
                    <div style={{ color: "#fff", fontWeight: "bold", fontSize: "20px", borderRadius: "0px 10px", backgroundColor: "#2b0980", width: "270px", height: "25px", textAlign: "center", borderRight: "4px solid #e00241" }}>
                        Disclaimer
                    </div>
                    <div style={{
                        width: "100%",
                        display: "flex",
                        background: "#fff",
                        padding: "20px"
                    }}>
                        1. The testing laboratory does not bear responsibility for the details provided in the TRF.<br />
                        2. It is presumed that the received specimen belongs to the patient named or identified in the test request form.<br />
                        3. This is a screening test only. Negative screening does not rule out the possibility of underlying metabolic / genetic disorder.<br />
                        4. The metabolites and health condition mapping is not mutually unique and there can be other forms in which an abnormality maybe apparent.<br />
                        5.The health condition may not exclusively be an outcome of the disorder in consideration. If the new bom is premature, retest is suggested when adjust-
                        ed gestational age is 40 weeks.<br />
                        6.  Allinvestigations have their limitations which depend on the sensitivity and specificity of assay procedures as well as the quality of specimen received
                        by the laboratory.<br />
                        7. The baby’s health should be monitored in case of any unhealthy condition with in or beyond the scope of this test.<br />
                        8. This report is not subject to use for any medicolegal purpose.
                    </div>
                </div>
                <div >

                

                </div>
                {/* doctor name */}
                <div style={{ padding: "20px", marginTop: "-2px" }} className="margin">
                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            background: "#fff",

                        }}
                    >
                        <div style={{ width: "65%", textAlign: "left", padding: 15 }}>
                        </div>
                        {nbsDoctorType?.map((list: any, index: number) => {
                            return (
                                <div style={{ width: "35%", padding: 15, textAlign: "left" }}>
                                    <img
                                        alt="description of image"
                                        style={{ width: "230px", height: "100px" }}
                                        src={"https://static-redcliffelabs.s3.amazonaws.com/media/ticket-document/14642558/Dr_Ankur_Jindal.jpg"}
                                    />
                                </div>
                            )
                        })}
                    </div>
                </div>
                <div style={{ padding: "20", }}>
                    <div style={{ color: "#fff", fontWeight: "bold", fontSize: "20px", borderRadius: "0px 10px", backgroundColor: "#2b0980", width: "270px", textAlign: "center", borderRight: "4px solid #e00241" }}>

                    </div>
                    <div style={{ width: "90%", marginLeft: "10px" }} className="tablecontent">
                        {/* <h6>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna</h6> */}.
                    </div>
                    <div style={{ width: "90%", marginLeft: "10px" }} className="tablecontent4">
                        {/* <h6>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna</h6> */}.
                    </div>
                </div>
                <div aria-hidden style={{ height: Math.max(0, (baseTableValues.length - (thirdP === "edit"
                    ? tableValues.filter((row: any) =>
                        !row.isDeleted &&
                        row.value !== "" &&
                        row.value !== null &&
                        row.value !== undefined &&
                        row.value !== "null"
                        ).length
                    : tableValues.filter((row: any) => !row.isDeleted).length
                    )) * 56), visibility: "hidden" }} />
                
               
                <div style={{ padding: "20" }} >
                    <div style={{ backgroundColor: "#2b0980", borderRadius: "10px", textAlign: "center", fontWeight: "bold", color: "white", height: "30px", fontSize: "20px" }} className="nbs-merginLeft">
                        CONDITIONS OF REPORTING
                    </div>
                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            background: "#fff",
                            padding: "25px"
                        }}
                    >
                        <ul>
                            <li>It is Presumed that specimen belongs to patient named or identified, such verification being carried out at
                                the point of generation of said specimen </li>

                            <li>A test might not be performed due to following reason</li>

                            - Specimen Quantity not sufficient (Inadequate collection/spillage during transit)<br />

                            - Specimen Quality not acceptable (Hemolysis/clotted/lipemic.)<br />

                            - Incorrect sample type<br />

                            - Test cancelled either on request of patient or doctor<br />

                            In any of the above case a fresh specimen will be required for testing and reporting<br />

                            <li> The results of the tests may vary from lab to lab ; time to time for the same patient </li>

                            <li> The reported results are dependent on individual assay methods, equipment, method sensitivity,
                                specificity and quality of the specimen received</li>

                            <li>Partial representation of report is not allowed</li>

                            <li>The reported tests are for the notification of the referring doctor, only to assist him/her in the
                                diagnosis and management of the patient</li>

                            <li>lf Sample collection date is not stated on test requisition form, the current date will be printed by
                                default as the date of collection.</li>

                            <li>Report with status “Preliminary” means one or more test are yet to be reported</li>
                            <li>This report is not valid for Medico Legal Purpose</li>

                            <li>Applicable Jurisdiction will be of “Delhi” for any dispute/claim concerning the test(s) & results of the test (s)</li>
                        </ul>
                    </div>
                </div>
                {/* footer section starting */}
                <div className="page-footer">

                    {/* footer area */}
                    <div style={{ padding: "20px" }}>
                        <div
                            style={{
                                width: "100%",
                                display: "flex",
                                background: "#fff",
                            }}
                        >
                            <div style={{ width: "15%", textAlign: "left", padding: 15 }}>
                                <h3>
                                    <QRCode value={`https://lead.redcliffelabs.com/verify-report/?booking=${uuid}&api_key=pvkbv24f916fa28-dd38-4ba5-ad6c-8a78d0`} size={115} />
                                </h3>
                            </div>
                            <div style={{ width: "85%", textAlign: "left", padding: 10, marginTop: "-3px" }}>
                                {nbsReport[0]?.booking_type === "b2b" ?
                                    <div style={{ width: "100%", display: "flex", margin: "10px 0px", marginTop: "9px" }}>
                                        <div style={{ width: "33%", marginLeft: 8 }}><img src={callIcon} alt="logo" style={{ width: "20px", margin: "2px" }} /> <span style={{ color: "red" }}>928-909-0609</span></div>
                                        <div style={{ width: "33%", marginLeft: 8 }}><img src={maillIcon} alt="logo" style={{ width: "20px", margin: "2px" }} /><span style={{ color: "red" }}>ccsupport@redcliffelabs.com</span></div>
                                        <div style={{ width: "33%", marginLeft: 8 }}><img src={browserIcon} alt="logo" style={{ width: "20px", margin: "2px" }} /><span style={{ color: "red" }}>www.redcliffelabs.com</span></div>
                                    </div> :
                                    <div style={{ width: "100%", display: "flex", margin: "10px 0px", marginTop: "9px" }}>
                                        <div style={{ width: "33%", marginLeft: 8 }}><img src={callIcon} alt="logo" style={{ width: "20px", margin: "2px" }} /> <span style={{ color: "red" }}>928-909-0606</span></div>
                                        <div style={{ width: "33%", marginLeft: 8 }}><img src={maillIcon} alt="logo" style={{ width: "20px", margin: "2px" }} /><span style={{ color: "red" }}>care@redcliffelabs.com</span></div>
                                        <div style={{ width: "33%", marginLeft: 8 }}><img src={browserIcon} alt="logo" style={{ width: "20px", margin: "2px" }} /><span style={{ color: "red" }}>www.redcliffelabs.com</span></div>
                                    </div>}
                                <div style={{ width: "100%", display: "flex", margin: "10px 0px", textAlign: "left", marginBottom: "-15px" }}>
                                    <h6 style={{ marginLeft: "16px" }}> Redcliffe Lifetech Pvt. Ltd. (Unit of Redcliffe Lifetech inc,USA) H-31,Sector-63,Noida, Uttar Pradesh, 201301
                                    </h6>
                                </div>
                                <div style={{ width: "100%", display: "flex", margin: "10px 0px", marginLeft: "16px", textAlign: "left" }}>
                                    <p style={{ fontSize: "13px", marginTop: "3px" }}> All Lab are subjected to clinical interpretations by qualified medical professional and this report is not subject to use for any medico-legal purpose.</p>
                                </div>
                                <hr style={{ backgroundColor: "red", width: "100%", height: "8px", marginTop: "10px" }} />
                            </div>
                        </div>
                        {/* second page  */}

                    </div>
                    {/* footer area closed */}

                </div>
                {/* footer section end */}

                 {
                                                                                               uuid && (
                                                                                                   <div className="hide-section-rating">
                                                                                                       <NpsRating bookingId={firstP} uuid={uuid} />
                                                                                                   </div>
                                                                                               )
                                                                                           }
            </div>
              

            {/* last Page */}
        </div>
    )
};

const mapStateToProps = (state: any) => ({
    reportListParameter: state.LimsAdminReducer.reportListParameter,
    fetchNbsdata: state.LimsAdminReducer.fetchNbsdata,
    bookingnbsform: state.LimsAdminReducer.bookingnbsform,
    updatedReportData: state.LimsAdminReducer.updatedReportData,
});

export default connect(mapStateToProps, {
    getReportTemplateParameter,
    getNbsData,
    getBookingByNbsForm,
    createNewReport,
    getUpdatedCustomerReportData,
    updateReport,
    resetBookingData,
})(NbsReport);
